function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Text, Flex } from "sprout-ui-primitives";
import { useSearchQuery, UserType, ItemType } from "sprout-graphql";
import { getReadableDescription, getItemUrl, isNotNullish } from "sprout-lib";
import { CardLink } from "../Card";
import SearchItem, { SearchItemWrapper } from "./Search_Item";
import SearchItemPlaceholder from "./Search_Item_Placeholder";
import useSearchQueryVariables from "./useSearchQueryVariables";
const SearchDropdown = (props)=>{
    var ref, ref1;
    const { searchTerm , getItemProps  } = props;
    const { includeUsers , includeItems , operators , topicId  } = useSearchQueryVariables();
    const skip = searchTerm.length === 0;
    const { loading , error , data  } = useSearchQuery({
        skip,
        variables: {
            inRootTopicId: topicId,
            searchItemsValue: includeItems ? [
                searchTerm,
                ...operators
            ].join(" ") : "",
            searchUsersValue: includeUsers ? searchTerm : undefined,
            includeItems,
            includeUsers
        },
        fetchPolicy: "cache-and-network"
    });
    if (skip) return null;
    const users = (data === null || data === void 0 ? void 0 : (ref = data.users) === null || ref === void 0 ? void 0 : ref.nodes) || [];
    const items = (data === null || data === void 0 ? void 0 : (ref1 = data.items) === null || ref1 === void 0 ? void 0 : ref1.nodes) || [];
    if (loading || searchTerm.length === 0) {
        if (includeUsers) return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(SearchItemPlaceholder, {
                    type: UserType.User
                }),
                /*#__PURE__*/ _jsx(SearchItemPlaceholder, {
                    type: UserType.User
                }),
                /*#__PURE__*/ _jsx(SearchItemPlaceholder, {
                    type: UserType.User
                })
            ]
        });
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(SearchItemPlaceholder, {
                    type: ItemType.Post
                }),
                /*#__PURE__*/ _jsx(SearchItemPlaceholder, {
                    type: ItemType.Post
                }),
                operators.includes("kind:TOPIC") ? /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(SearchItemPlaceholder, {
                            type: ItemType.Topic
                        }),
                        /*#__PURE__*/ _jsx(SearchItemPlaceholder, {
                            type: ItemType.Topic
                        })
                    ]
                }) : /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(SearchItemPlaceholder, {
                            type: ItemType.Post
                        }),
                        /*#__PURE__*/ _jsx(SearchItemPlaceholder, {
                            type: ItemType.Post
                        })
                    ]
                })
            ]
        });
    }
    if (error) return /*#__PURE__*/ _jsx(Flex, {
        p: "24px 16px",
        children: /*#__PURE__*/ _jsx(Text, {
            color: "black.60",
            children: "Something unexpected happened. Please try again later"
        })
    });
    if (users.length === 0 && items.length === 0) {
        const url = "/";
        return /*#__PURE__*/ _jsxs(SearchItemWrapper, _objectSpread({}, getItemProps({
            item: {
                url
            }
        }), {
            children: [
                /*#__PURE__*/ _jsx(CardLink, {
                    to: url
                }),
                /*#__PURE__*/ _jsx(Text, {
                    lineHeight: "24px",
                    p: "14px 16px",
                    color: "black.60",
                    children: `Search for "${searchTerm}"`
                })
            ]
        }));
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            users.map((user)=>{
                const { nodeId  } = user;
                const url = `/${user.username}`;
                return /*#__PURE__*/ _jsx(SearchItem, _objectSpread({
                    owner: user,
                    label: user.username,
                    url: url
                }, getItemProps({
                    item: {
                        url
                    }
                })), nodeId);
            }),
            items.map((item)=>{
                const { type , nodeId , linkImage , linkImages , linkTitle , rootTopicOrSelf , parentTopic ,  } = item;
                const label = type === ItemType.Post ? item.description ? getReadableDescription(item.description) : linkTitle || undefined : item.title || "No title";
                const image = type === ItemType.Post ? linkImage || undefined : linkImages ? linkImages[0] || undefined : undefined;
                const url = getItemUrl(item, item.owner, true);
                if (!url) return null;
                return /*#__PURE__*/ _jsx(SearchItem, _objectSpread({
                    rootTopic: rootTopicOrSelf || undefined,
                    parentTopic: parentTopic || undefined,
                    type: type,
                    label: label,
                    image: image,
                    url: url
                }, getItemProps({
                    item: {
                        url
                    }
                })), nodeId);
            }).filter(isNotNullish)
        ]
    });
};
export default SearchDropdown;
